var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('p', [_vm._v("redis 作为缓存服务，同样也提供了持久化配置选项，支持4种持久化模式：AOF、RDB、NO persistence（不持久化）、RDB + AOF（组合模式，4.0+版本支持）")]), _vm._v(" "), _c('p', [_vm._v("官方文档："), _c('a', {
    attrs: {
      "href": "https://redis.io/docs/management/persistence/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://redis.io/docs/management/persistence/"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "aof-append-only-file"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#aof-append-only-file"
    }
  }, [_vm._v("#")]), _vm._v(" AOF（append only file）")]), _vm._v(" "), _c('p', [_vm._v("AOF 模式在数据写入内存后再写一条命令到 AOF 文件中，类似 MySQL 的 redo log。")]), _vm._v(" "), _c('p', [_vm._v("例如执行一个 set 操作")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("127.0")]), _vm._v(".0.1:637"), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token file-descriptor important"
    }
  }, [_vm._v("9")]), _vm._v(">")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("set")]), _vm._v(" hello world\nOK\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br')])]), _c('p', [_vm._v("对应的日志")]), _vm._v(" "), _c('div', {
    staticClass: "language- line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("*2\n$6\nSELECT\n$1\n0\n*3\n$3\nset\n$5\nhello\n$5\nworld\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br')])]), _c('p', [_vm._v("稍微解释一下含义")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("*2")]), _vm._v("表示命令氛围2部分")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("$6")]), _vm._v("表示接下来的部分包含6个字符，即："), _c('code', [_vm._v("SELECT")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("$1")]), _vm._v("表示接下来部分包含1个字符，即："), _c('code', [_vm._v("0")])])]), _vm._v(" "), _c('p', [_vm._v("组合起来就得到"), _c('code', [_vm._v("SELECT 0")]), _vm._v("，即选择db 0数据库。")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("*3")]), _vm._v("表示命令包含3部分")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("$3")]), _vm._v("表示接下来的部分包含3个字符，即："), _c('code', [_vm._v("set")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("$5")]), _vm._v("表示接下来的部分包含5个字符，即："), _c('code', [_vm._v("hello")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("$5")]), _vm._v("表示接下来的部分包含5个字符，即："), _c('code', [_vm._v("world")])])]), _vm._v(" "), _c('p', [_vm._v("组合起来就得到"), _c('code', [_vm._v("set hello world")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("当 redis 重启时，就会根据 AOF 日志重放历史命令，生成对应数据。")]), _vm._v(" "), _c('p', [_vm._v("如果每次写操作都要写 AOF 日志（磁盘IO），对 redis 性能影响比较大，所以 redis 提供了3种写回策略，对应参数是"), _c('code', [_vm._v("appendfsync")]), _vm._v("。")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("appendfsync")]), _vm._v(" "), _c('th', [_vm._v("优点")]), _vm._v(" "), _c('th', [_vm._v("缺点")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("always")]), _vm._v(" "), _c('td', [_vm._v("数据基本不丢失")]), _vm._v(" "), _c('td', [_vm._v("每次都要磁盘IO，性能差")]), _vm._v(" "), _c('td', [_vm._v("同步写回，每个写操作都落盘，通常不建议使用")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("everysec")]), _vm._v(" "), _c('td', [_vm._v("性能适中")]), _vm._v(" "), _c('td', [_vm._v("宕机可能丢失1秒数据")]), _vm._v(" "), _c('td', [_vm._v("每秒写回")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("no")]), _vm._v(" "), _c('td', [_vm._v("高性能")]), _vm._v(" "), _c('td', [_vm._v("宕机丢失较多数据，不可控")]), _vm._v(" "), _c('td', [_vm._v("日志写入缓冲区，由操作系统控制写回")])])])]), _vm._v(" "), _c('p', [_vm._v("因为 AOF 是记录执行的命令，如果运行时间比较长，aof 日志文件会比较大，同样会在数据恢复时也需要较长时间。为了解决这个问题，引入了 aof 重写机制。")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "aof-重写-aofrewrite"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#aof-重写-aofrewrite"
    }
  }, [_vm._v("#")]), _vm._v(" AOF 重写（aofrewrite）")]), _vm._v(" "), _c('p', [_vm._v("AOF 重写，是将多个命令合并成一个命令，例如：")]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("set")]), _vm._v(" a hello\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token builtin class-name"
    }
  }, [_vm._v("set")]), _vm._v(" a world\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br')])]), _c('p', [_c('code', [_vm._v("a")]), _vm._v("最终的值是"), _c('code', [_vm._v("world")]), _vm._v("，那么只需要记录"), _c('code', [_vm._v("set a world")]), _vm._v("就可以了，这样就能压缩 aof 文件大小，在数据恢复时需要执行的命令也会减少，可一定程度提高数据恢复速度。")]), _vm._v(" "), _c('p', [_vm._v("触发时机：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("执行"), _c('code', [_vm._v("bgrewriteaof")]), _vm._v("命令")]), _vm._v(" "), _c('li', [_vm._v("到达配置阈值")])]), _vm._v(" "), _c('div', {
    staticClass: "language-conf line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("# 自动触发 aofrewrite 的文件大小\nauto-aof-rewrite-min-size 128mb\n# 自动触发 aofrewrite 的增长率\n# 例如配置是100，当文件大小到达 128mb 时，触发第一次 aofrewrite\n# 当文件大小到达 265mb 时（前一次大小的 100%），触发第二次 aofrewrite\nauto-aof-rewrite-percentage 100\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br')])]), _c('p', [_vm._v("aof 重写会从主进程 fork 一个子进程来完成，整个过程不会阻塞主线程，在重写没有完成期间的命令，会写入"), _c('code', [_vm._v("aof 重写缓冲区")]), _vm._v("。")]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./02.aof-rewrite.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("完整配置参考")]), _vm._v(" "), _c('div', {
    staticClass: "language-conf line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("# 开启 aof 日志\nappendonly yes\n# appendfsync always\n# appendfsync no\nappendfsync everysec\n# aof 日志文件路径\nappendfilename \"appendonly.aof\"\n# 自动触发 aofrewrite 的文件大小\nauto-aof-rewrite-min-size 128mb\n# 自动触发 aofrewrite 的增长率\nauto-aof-rewrite-percentage 100\n# 当 aof 文件出现错误时，是否忽略错误继续执行\naof-load-truncated yes\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "rdb"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#rdb"
    }
  }, [_vm._v("#")]), _vm._v(" RDB")]), _vm._v(" "), _c('p', [_vm._v("RDB 保存的是某一时刻的全量内存快照，记录的是数据（二进制），AOF 记录的是操作。在服务重启恢复数据的时候比 AOF 速度更快。")]), _vm._v(" "), _c('p', [_vm._v("但因为是生成全量快照，所以会比 AOF 追加的方式需要更多时间来生成备份。")]), _vm._v(" "), _c('p', [_vm._v("触发生成 RDB 机制")]), _vm._v(" "), _c('ol', [_c('li', [_c('p', [_vm._v("执行"), _c('code', [_vm._v("save")]), _vm._v("命令，谨慎使用，会阻塞主线程，在一些特殊场景可以使用（例如停机升级）")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("执行"), _c('code', [_vm._v("bgsave")]), _vm._v("命令，和 AOF 一样，紫金城 fork 主进程来完成快照生成，不会阻塞主线程对外服务，同样也是 copy-on-write 机制，生成 RDB 文件过程中只会对修改的数据增加内存开销")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("配置文件定时生成")]), _vm._v(" "), _c('div', {
    staticClass: "language-conf line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("# 当条件满足时自动触发 bgsave\n# save <seconds> <changes>\n# # 在900秒内发生1次修改\nsave 900 1\n# 在300秒内发生10次修改\nsave 300 10\n# 在60秒内发生10000次修改\nsave 60 10000\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br')])])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("全量复制（主从同步时）")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("debug reload")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("shuedown")])])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "混合模式"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#混合模式"
    }
  }, [_vm._v("#")]), _vm._v(" 混合模式")]), _vm._v(" "), _c('p', [_vm._v("AOF 和 RDB 各有优缺点")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("持久化")]), _vm._v(" "), _c('th', [_vm._v("文件生成效率")]), _vm._v(" "), _c('th', [_vm._v("数据恢复速度")]), _vm._v(" "), _c('th', [_vm._v("文件大小")]), _vm._v(" "), _c('th', [_vm._v("数据丢失情况")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("AOF")]), _vm._v(" "), _c('td', [_vm._v("快")]), _vm._v(" "), _c('td', [_vm._v("慢")]), _vm._v(" "), _c('td', [_vm._v("大，和写操作次数线性增长")]), _vm._v(" "), _c('td', [_vm._v("配置为"), _c('code', [_vm._v("everysec")]), _vm._v("丢失1秒数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RDB")]), _vm._v(" "), _c('td', [_vm._v("慢")]), _vm._v(" "), _c('td', [_vm._v("快")]), _vm._v(" "), _c('td', [_vm._v("小，和数据量线下增长")]), _vm._v(" "), _c('td', [_vm._v("丢失生成快照期间的数据，由数据量大小决定")])])])]), _vm._v(" "), _c('p', [_vm._v("在 redis 4+版本之后，支持了混合模式。开启混合模式后，执行"), _c('code', [_vm._v("bgrewriteaof")]), _vm._v("命令，AOF文件头部将会以 RDB 格式存储，在数据备份过程中产生的增量数据，将会以 AOF 方式追加在文件末尾。")]), _vm._v(" "), _c('p', [_vm._v("nodejs 写了个测试脚本，在开启混合模式的情况下，往 redis 写了1k万个数据。")]), _vm._v(" "), _c('div', {
    staticClass: "language-js line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-js"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("import")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("{")]), _vm._v(" createClient "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("}")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("\"redis\"")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("const")]), _vm._v(" redis "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("createClient")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("{")]), _vm._v("\n  "), _c('span', {
    pre: true,
    attrs: {
      "class": "token literal-property property"
    }
  }, [_vm._v("url")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("'redis://localhost:6379'")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("}")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("async")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("function")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("main")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("{")]), _vm._v("\n  "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("await")]), _vm._v(" redis"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(".")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("connect")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n\n  "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("for")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("let")]), _vm._v(" i "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("=")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("0")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v(" i "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token number"
    }
  }, [_vm._v("10000000")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v(" i"), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("++")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("{")]), _vm._v("\n    "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("await")]), _vm._v(" redis"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(".")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("set")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token template-string"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token template-punctuation string"
    }
  }, [_vm._v("`")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("key-")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token interpolation"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token interpolation-punctuation punctuation"
    }
  }, [_vm._v("${")]), _vm._v("i"), _c('span', {
    pre: true,
    attrs: {
      "class": "token interpolation-punctuation punctuation"
    }
  }, [_vm._v("}")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token template-punctuation string"
    }
  }, [_vm._v("`")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(",")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token template-string"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token template-punctuation string"
    }
  }, [_vm._v("`")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token string"
    }
  }, [_vm._v("value-")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token interpolation"
    }
  }, [_c('span', {
    pre: true,
    attrs: {
      "class": "token interpolation-punctuation punctuation"
    }
  }, [_vm._v("${")]), _vm._v("i"), _c('span', {
    pre: true,
    attrs: {
      "class": "token interpolation-punctuation punctuation"
    }
  }, [_vm._v("}")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token template-punctuation string"
    }
  }, [_vm._v("`")])]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n  "), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("}")]), _vm._v("\n  "), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("await")]), _vm._v(" redis"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(".")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("disconnect")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(";")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("}")]), _vm._v("\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token keyword"
    }
  }, [_vm._v("await")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("main")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v("(")]), _c('span', {
    pre: true,
    attrs: {
      "class": "token punctuation"
    }
  }, [_vm._v(")")]), _vm._v("\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("14")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("15")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("16")]), _c('br')])]), _c('p', [_vm._v("在"), _c('code', [_vm._v("Apple M1 Pro 16G内存")]), _vm._v("上测试，执行"), _c('code', [_vm._v("save")]), _vm._v("操作（阻塞方式生产 RDB 文件），需要6.85s，生成的文件大小是。")]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("大小")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("AOF")]), _vm._v(" "), _c('td', [_vm._v("304M")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("AOF 重写")]), _vm._v(" "), _c('td', [_vm._v("255M（混合模式文件头就是以 RDB 格式保存，符合理论）")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("RDB")]), _vm._v(" "), _c('td', [_vm._v("255M")])])])]), _vm._v(" "), _c('p', [_vm._v("配置参考")]), _vm._v(" "), _c('div', {
    staticClass: "language-conf line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-text"
    }
  }, [_c('code', [_vm._v("# 关闭自动 RDB\nsave \"\"\n# rdb 文件名\ndbfilename dump.rdb\ndir ./\nstop-writes-on-bgsave-error yes\n# 文件压缩\nrdbcompression yes\n# 检查文件合法性\nrdbchecksum yes\n\n# 开启 aof\nappendonly yes\n# aof 文件名\nappendfilename \"appendonly.aof\"\n# 每秒刷盘\nappendfsync everysec\n\n# 当 aof 文件出现错误时，是否忽略错误继续执行\naof-load-truncated yes\n# 开启混合模式\naof-use-rdb-preamble yes\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("7")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("8")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("9")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("10")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("11")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("12")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("13")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("14")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("15")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("16")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("17")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("18")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("19")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("20")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("21")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("22")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "常见问题"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#常见问题"
    }
  }, [_vm._v("#")]), _vm._v(" 常见问题")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("虽然 Redis 是单线程提供服务的，但是还会有很多其他后台线程，例如生成 AOF 和 RDB 文件的线程，删除过期 key 的线程等。")]), _vm._v(" "), _c('li', [_vm._v("虽然生成 AOF 和 RDB 时不会真正拷贝物理内存，但是 copy-on-write 机制在数据写入时为了不影响主线程数据写入，会将内存拷贝一份需要修改的数据")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "案例分析"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#案例分析"
    }
  }, [_vm._v("#")]), _vm._v(" 案例分析")]), _vm._v(" "), _c('p', [_vm._v("如果一个双核服务器部署 redis 实例，在数据量比较大的情况下执行"), _c('code', [_vm._v("bgsave")]), _vm._v("命令会有什么风险？")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("redis 除了主线程外，还有后台线程，数据量大的情况下执行"), _c('code', [_vm._v("bgsave")]), _vm._v("需要占用比较多的时间，主线程占用一个cpu，只剩下一个cpu，就造成资源竞争，影响性能")])]), _vm._v(" "), _c('p', [_vm._v("在一个读写比例大概 8: 2 的 redis 实例中，当前服务器物理内存4G，redis 中有3G数据，执行"), _c('code', [_vm._v("bgsave")]), _vm._v("或者"), _c('code', [_vm._v("bgrewriteaof")]), _vm._v("命令会有什么风险？")]), _vm._v(" "), _c('blockquote', [_c('p', [_c('code', [_vm._v("bgsave")]), _vm._v("或者"), _c('code', [_vm._v("bgrewriteaof")]), _vm._v("都是 fork 主进程，使用 copy-on-write 机制生成备份文件，在次期间，写操作占0.8，也就是2.4G数据，导致物理内存不足，会使用 swap 分区充当虚拟内存，性能会严重下降。如果没有开启 swap，还会导致 OOM。")])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "参考"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#参考"
    }
  }, [_vm._v("#")]), _vm._v(" 参考")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://redis.io/docs/management/persistence/",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://redis.io/docs/management/persistence/"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://time.geekbang.org/column/article/271839",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://time.geekbang.org/column/article/271839"), _c('OutboundLink')], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };